// extracted by mini-css-extract-plugin
export default {"container":"error_container__FRubr","container__title":"error_container__title__cncLO","container__text":"error_container__text__wm8pb"};